// import React from "react";
// import slulogo from "../assets/slu-logo-blue.png";
// import { useNavigate } from "react-router-dom";

// export default function Navbar() {
//   const navigate = useNavigate();
//   const isLoggedIn = Boolean(localStorage.getItem("authToken"));
//   const isAdmin = isLoggedIn && localStorage.getItem("userType") === "admin";

//   return (
//     <>
//       {/* Top strip */}
//       <div className="flex justify-end bg-[#003da5] text-white p-3">
//         <nav className="px-6 space-x-4 font-['Crimson_Pro'] text-[16px] font-bold">
//          {isLoggedIn ? (
//            <button
//              onClick={() => {
//                localStorage.removeItem("authToken");
//                localStorage.removeItem("userType");
//                navigate("/");
//              }}
//              className="cursor-pointer"
//            >
//              Logout
//            </button>
//          ) : (
//            <button
//              onClick={() => navigate("/login")}
//              className="cursor-pointer"
//            >
//              Login
//            </button>
//          )}

//           <button onClick={() => navigate("/contact")} className="cursor-pointer">Contact US</button>
//           {/* <a href="https://www.slu.edu/apply.php">Apply</a> */}
//         </nav>
//       </div>

//       {/* Main Navbar */}
//       <section className="flex justify-between items-center h-22 bg-white border-b border-gray-300">
//         {/* Logo */}
//         <img
//           src={slulogo}
//           alt="TWA Logo"
//           className="ml-10 h-[150px] cursor-pointer"
//           onClick={() => navigate("/")}
//         />

//         {/* Navigation buttons */}
//         <div className="flex justify-end pr-8 space-x-6 font-['Crimson_Pro'] text-md text-[#003DA5] font-bold">
//           <button
//             onClick={() => navigate("/who-we-are")}
//             className="cursor-pointer"
//           >
//             Who We Are
//           </button>
//           <button
//             onClick={() => navigate("/who-we-serve")}
//             className="cursor-pointer"
//           >
//             Who We Serve
//           </button>
//           <button
//             onClick={() => navigate("/how-to-support")}
//             className="cursor-pointer"
//           >
//             How to Support
//           </button>
//           <button onClick={() => navigate("/news")} className="cursor-pointer">
//             News
//           </button>
//           {isLoggedIn && (
//             <button
//               onClick={() => navigate("/video")}
//               className="cursor-pointer"
//             >
//               Video Platform
//             </button>
//           )}
//           {isAdmin && (
//             <button
//               onClick={() => navigate("/admin")}
//               className="cursor-pointer"
//             >
//               Admin
//             </button>
//           )}
//           <button onClick={() => navigate("/profile")} className="cursor-pointer">
//             Profile
//           </button>

//           {/* <button
//             onClick={() => navigate("/contact")}
//             className="cursor-pointer"
//           >
//             Contact
//           </button> */}

//           {/* Logout (optional) */}
//           {/* <button
//             className="cursor-pointer outline px-3 py-2 rounded-xl hover:bg-[#003DA5] hover:text-white"
//             onClick={() => navigate("/")}
//           >
//             Logout
//           </button> */}
//         </div>
//       </section>
//     </>
//   );
// }

// import React, { useState } from "react";
// import slulogo from "../assets/logo_image.png";
// import { useNavigate } from "react-router-dom";
// import { Menu, X } from "lucide-react";

// export default function Navbar() {
//   const navigate = useNavigate();
//   const [isOpen, setIsOpen] = useState(false);

//   const isLoggedIn = Boolean(localStorage.getItem("authToken"));
//   const isAdmin = isLoggedIn && localStorage.getItem("userType") === "admin";

//   const toggleMenu = () => setIsOpen(!isOpen);

//   const handleLogout = () => {
//     localStorage.removeItem("authToken");
//     localStorage.removeItem("userType");
//     navigate("/");
//   };

//   return (
//     <>
//       {/* Top strip */}
//       <div className="flex justify-end bg-[#003da5] text-white p-3">
//         <nav className="px-6 space-x-4 font-['Crimson_Pro'] text-sm md:text-[16px] font-bold">
//           {isLoggedIn ? (
//             <button onClick={handleLogout} className="cursor-pointer">
//               Logout
//             </button>
//           ) : (
//             <button onClick={() => navigate("/login")} className="cursor-pointer">
//               Login
//             </button>
//           )}
//           <button onClick={() => navigate("/contact")} className="cursor-pointer">
//             Contact Us
//           </button>
//         </nav>
//       </div>

//       {/* Main Navbar */}
//       <section className="flex justify-between items-center bg-white border-b border-gray-300 px-6">
//         {/* Logo */}
//         <img
//           src={slulogo}
//           alt="TWA Logo"
//           className="h-[80px] md:h-[100px] lg:h-[90px] cursor-pointer m-4"
//           onClick={() => navigate("/")}
//         />

//         {/* Desktop Nav */}
//         <div className="hidden md:flex justify-end pr-4 space-x-4 md:space-x-6 font-['Crimson_Pro'] text-sm md:text-md lg:text-lg text-[#003DA5] font-bold">
//           <button className='cursor-pointer' onClick={() => navigate("/who-we-are")}>Who We Are</button>
//           <button className='cursor-pointer' onClick={() => navigate("/who-we-serve")}>Who We Serve</button>
//           <button className='cursor-pointer' onClick={() => navigate("/how-to-support")}>How to Support</button>
//           <button className='cursor-pointer' onClick={() => navigate("/news")}>News</button>
//           {isLoggedIn && <button className='cursor-pointer' onClick={() => navigate("/video")}>Video Platform</button>}
//           {isAdmin && <button className='cursor-pointer' onClick={() => navigate("/admin")}>Admin</button>}
//           <button className='cursor-pointer' onClick={() => navigate("/profile")}>Profile</button>
//         </div>

//         {/* Mobile Hamburger */}
//         <div className="md:hidden">
//           <button onClick={toggleMenu}>
//             {isOpen ? <X size={28} /> : <Menu size={28} />}
//           </button>
//         </div>
//       </section>

//       {/* Mobile Dropdown */}
//       {isOpen && (
//         <div className="md:hidden bg-white border-b border-gray-200 px-6 py-4 font-['Crimson_Pro'] text-[#003DA5] font-bold space-y-4">
//           <button
//             onClick={() => {
//               navigate("/who-we-are");
//               toggleMenu();
//             }}
//             className="block w-full text-left"
//           >
//             Who We Are
//           </button>
//           <button
//             onClick={() => {
//               navigate("/who-we-serve");
//               toggleMenu();
//             }}
//             className="block w-full text-left"
//           >
//             Who We Serve
//           </button>
//           <button
//             onClick={() => {
//               navigate("/how-to-support");
//               toggleMenu();
//             }}
//             className="block w-full text-left"
//           >
//             How to Support
//           </button>
//           <button
//             onClick={() => {
//               navigate("/news");
//               toggleMenu();
//             }}
//             className="block w-full text-left"
//           >
//             News
//           </button>
//           {isLoggedIn && (
//             <button
//               onClick={() => {
//                 navigate("/video");
//                 toggleMenu();
//               }}
//               className="block w-full text-left"
//             >
//               Video Platform
//             </button>
//           )}
//           {isAdmin && (
//             <button
//               onClick={() => {
//                 navigate("/admin");
//                 toggleMenu();
//               }}
//               className="block w-full text-left"
//             >
//               Admin
//             </button>
//           )}
//           <button
//             onClick={() => {
//               navigate("/profile");
//               toggleMenu();
//             }}
//             className="block w-full text-left"
//           >
//             Profile
//           </button>
//         </div>
//       )}
//     </>
//   );
// }

// import React, { useState } from "react";
// import slulogo from "../assets/logo_image.png";
// import { useNavigate } from "react-router-dom";
// import { Menu, X, ChevronDown } from "lucide-react";

// export default function Navbar() {
//   const navigate = useNavigate();
//   const [isOpen, setIsOpen] = useState(false);
//   const [showVideoPlatformDropdown, setShowVideoPlatformDropdown] = useState(false);

//   const isLoggedIn = Boolean(localStorage.getItem("authToken"));
//   const isAdmin = isLoggedIn && localStorage.getItem("userType") === "admin";

//   const toggleMenu = () => setIsOpen(!isOpen);

//   const handleLogout = () => {
//     localStorage.removeItem("authToken");
//     localStorage.removeItem("userType");
//     navigate("/");
//   };

//   return (
//     <>
//       {/* Top strip */}
//       <div className="flex justify-end bg-[#003da5] text-white p-3">
//         <nav className="px-6 space-x-4 font-['Crimson_Pro'] text-sm md:text-[16px] font-bold">
//           {isLoggedIn ? (
//             <button onClick={handleLogout} className="cursor-pointer">
//               Logout
//             </button>
//           ) : (
//             <button onClick={() => navigate("/login")} className="cursor-pointer">
//               Login
//             </button>
//           )}
//           <button onClick={() => navigate("/contact")} className="cursor-pointer">
//             Contact Us
//           </button>
//         </nav>
//       </div>

//       {/* Main Navbar */}
//       <section className="flex justify-between items-center bg-white border-b border-gray-300 px-6">
//         {/* Logo */}
//         <img
//           src={slulogo}
//           alt="TWA Logo"
//           className="h-[80px] md:h-[100px] lg:h-[90px] cursor-pointer m-4"
//           onClick={() => navigate("/")}
//         />

//         {/* Desktop Nav */}
//         <div className="hidden md:flex justify-end pr-4 space-x-4 md:space-x-6 font-['Crimson_Pro'] text-sm md:text-md lg:text-lg text-[#003DA5] font-bold">
//           <button className='cursor-pointer' onClick={() => navigate("/who-we-are")}>Who We Are</button>
//           <button className='cursor-pointer' onClick={() => navigate("/who-we-serve")}>Who We Serve</button>
//           <button className='cursor-pointer' onClick={() => navigate("/how-to-support")}>How to Support</button>
//           <button className='cursor-pointer' onClick={() => navigate("/news")}>News</button>
//           {isLoggedIn && (
//             <div className="relative">
//               <button
//                 className='cursor-pointer flex items-center gap-1'
//                 onClick={() => setShowVideoPlatformDropdown(!showVideoPlatformDropdown)}
//               >
//                 Video Platform
//                 <ChevronDown size={16} className={`transition-transform ${showVideoPlatformDropdown ? 'rotate-180' : ''}`} />
//               </button>
//               {showVideoPlatformDropdown && (
//                 <div className="absolute top-full left-0 mt-2 bg-[#003DA5] shadow-lg w-48 z-50">
//                   <button
//                     onClick={() => {
//                       navigate("/regions");
//                       setShowVideoPlatformDropdown(false);
//                     }}
//                     className="block w-full text-left px-4 py-3 text-white border-b border-white hover:bg-[#0052cc] transition-colors"
//                   >
//                     Regions
//                   </button>
//                   <button
//                     onClick={() => {
//                       navigate("/industries");
//                       setShowVideoPlatformDropdown(false);
//                     }}
//                     className="block w-full text-left px-4 py-3 text-white border-b border-white hover:bg-[#0052cc] transition-colors"
//                   >
//                     Industries
//                   </button>
//                   <button
//                     onClick={() => {
//                       navigate("/videos");
//                       setShowVideoPlatformDropdown(false);
//                     }}
//                     className="block w-full text-left px-4 py-3 text-white border-b border-white hover:bg-[#0052cc] transition-colors"
//                   >
//                     Videos
//                   </button>
//                 </div>
//               )}
//             </div>
//           )}
//           {isAdmin && <button className='cursor-pointer' onClick={() => navigate("/admin")}>Admin</button>}
//           <button className='cursor-pointer' onClick={() => navigate("/profile")}>Profile</button>
//         </div>

//         {/* Mobile Hamburger */}
//         <div className="md:hidden">
//           <button onClick={toggleMenu}>
//             {isOpen ? <X size={28} /> : <Menu size={28} />}
//           </button>
//         </div>
//       </section>

//       {/* Mobile Dropdown */}
//       {isOpen && (
//         <div className="md:hidden bg-white border-b border-gray-200 px-6 py-4 font-['Crimson_Pro'] text-[#003DA5] font-bold space-y-4">
//           <button
//             onClick={() => {
//               navigate("/who-we-are");
//               toggleMenu();
//             }}
//             className="block w-full text-left"
//           >
//             Who We Are
//           </button>
//           <button
//             onClick={() => {
//               navigate("/who-we-serve");
//               toggleMenu();
//             }}
//             className="block w-full text-left"
//           >
//             Who We Serve
//           </button>
//           <button
//             onClick={() => {
//               navigate("/how-to-support");
//               toggleMenu();
//             }}
//             className="block w-full text-left"
//           >
//             How to Support
//           </button>
//           <button
//             onClick={() => {
//               navigate("/news");
//               toggleMenu();
//             }}
//             className="block w-full text-left"
//           >
//             News
//           </button>
//           {isLoggedIn && (
//             <>
//               <button
//                 onClick={() => {
//                   navigate("/regions");
//                   toggleMenu();
//                 }}
//                 className="block w-full text-left"
//               >
//                 Video Platform - Regions
//               </button>
//               <button
//                 onClick={() => {
//                   navigate("/industries");
//                   toggleMenu();
//                 }}
//                 className="block w-full text-left pl-4"
//               >
//                 - Industries
//               </button>
//               <button
//                 onClick={() => {
//                   navigate("/videos");
//                   toggleMenu();
//                 }}
//                 className="block w-full text-left pl-4"
//               >
//                 - Videos
//               </button>
//             </>
//           )}
//           {isAdmin && (
//             <button
//               onClick={() => {
//                 navigate("/admin");
//                 toggleMenu();
//               }}
//               className="block w-full text-left"
//             >
//               Admin
//             </button>
//           )}
//           <button
//             onClick={() => {
//               navigate("/profile");
//               toggleMenu();
//             }}
//             className="block w-full text-left"
//           >
//             Profile
//           </button>
//         </div>
//       )}
//     </>
//   );
// }

// import React, { useState } from "react";
// import slulogo from "../assets/logo_image.png";
// import { useNavigate } from "react-router-dom";
// import { Menu, X, ChevronDown } from "lucide-react";

// export default function Navbar() {
//   const navigate = useNavigate();
//   const [isOpen, setIsOpen] = useState(false);
//   const [showVideoPlatformDropdown, setShowVideoPlatformDropdown] =
//     useState(false);
//   const [showMobileVideoPlatformDropdown, setShowMobileVideoPlatformDropdown] =
//     useState(false);

//   const isLoggedIn = Boolean(localStorage.getItem("authToken"));
//   const isAdmin = isLoggedIn && localStorage.getItem("userType") === "admin";

//   const toggleMenu = () => setIsOpen(!isOpen);
//   const toggleMobileVideoPlatformDropdown = () =>
//     setShowMobileVideoPlatformDropdown(!showMobileVideoPlatformDropdown);

//   const handleLogout = () => {
//     localStorage.removeItem("authToken");
//     localStorage.removeItem("userType");
//     navigate("/");
//   };

//   return (
//     <>
//       {/* Top strip */}
//       <div className="flex justify-end bg-[#003da5] text-white p-3 font-['Archivo_Narrow ']">
//         <nav className="px-6 space-x-4  text-sm md:text-[16px] font-bold  font-['Archivo_Narrow ']">
//           {isLoggedIn ? (
//             <button onClick={handleLogout} className="cursor-pointer">
//               Logout
//             </button>
//           ) : (
//             <button
//               onClick={() => navigate("/login")}
//               className="cursor-pointer"
//             >
//               Login
//             </button>
//           )}
//           <button className="cursor-pointer">
//             <a href="https://engage.slu.edu/register/fund?sys:gift:fund=5f1377c9-952f-f0e2-4d65-15e8a9161ad6&sys:gift:notes=GIFT99W9">
//               Donate
//             </a>
//           </button>

//           <button
//             onClick={() => navigate("/contact")}
//             className="cursor-pointer"
//           >
//             Contact Us
//           </button>
//         </nav>
//       </div>

//       {/* Main Navbar */}
//       <section className="flex justify-between items-center bg-white border-b border-gray-300 px-6 h-28">
//         {/* Logo */}
//         <img
//           src={slulogo}
//           alt="TWA Logo"
//           className="h-14 w-auto object-contain cursor-pointer transform scale-200 m-16"
//           onClick={() => navigate("/")}
//         />

//         {/* Desktop Nav */}
//         <div className="hidden md:flex justify-end pr-4 space-x-4 md:space-x-6 font-['Archivo_Narrow '] text-sm md:text-md lg:text-lg text-[#003DA5] font-bold">
//           <button
//             className="cursor-pointer"
//             onClick={() => navigate("/who-we-are")}
//           >
//             Who We Are
//           </button>
//           <button
//             className="cursor-pointer"
//             onClick={() => navigate("/who-we-serve")}
//           >
//             Who We Serve
//           </button>
//           <button
//             className="cursor-pointer"
//             onClick={() => navigate("/how-to-support")}
//           >
//             How to Support
//           </button>
//           <button className="cursor-pointer" onClick={() => navigate("/news")}>
//             News
//           </button>
//            <button
//                 className="cursor-pointer flex items-center gap-1 cursor-pointer"
//                 onClick={() =>
//                   navigate("/video-platform/regions")
//                 }
//               >
//                 VRP
//                 </button>
//           {/* {isLoggedIn && (
//             <div className="relative"> */}

//               {/* <button
//                 className="cursor-pointer flex items-center gap-1 cursor-pointer"
//                 onClick={() =>
//                   setShowVideoPlatformDropdown(!showVideoPlatformDropdown)
//                 }
//               >
//                 VRP
//                 <ChevronDown
//                   size={16}
//                   className={`transition-transform ${
//                     showVideoPlatformDropdown ? "rotate-180" : ""
//                   }`}
//                 />
//               </button> */}
//               {/* {showVideoPlatformDropdown && (
//                 <div className="absolute top-full left-0 mt-2 bg-[#003DA5] text-white rounded-md shadow-lg w-40 z-50">

//                   <div className="absolute -top-2 left-10 w-4 h-4 bg-[#003DA5] transform rotate-45" />
//                   <button
//                     onClick={() => {
//                       navigate("/video-platform/regions");
//                       setShowVideoPlatformDropdown(false);
//                     }}
//                     className="block w-full text-left px-4 py-3 border-b border-white cursor-pointer"
//                   >
//                     Regions
//                   </button>
//                   <button
//                     onClick={() => {
//                       navigate("/video-platform/industries");
//                       setShowVideoPlatformDropdown(false);
//                     }}
//                     className="block w-full text-left px-4 py-3 border-b border-white cursor-pointer"
//                   >
//                     Industries
//                   </button>
//                   <button
//                     onClick={() => {
//                       navigate("/video-platform/videos");
//                       setShowVideoPlatformDropdown(false);
//                     }}
//                     className="block w-full text-left px-4 py-3 border-b border-white cursor-pointer"
//                   >
//                     Videos
//                   </button>
//                 </div>
//               )} */}
//             {/* </div>
//           )} */}
//           {isAdmin && (
//             <button
//               className="cursor-pointer"
//               onClick={() => navigate("/admin")}
//             >
//               Admin
//             </button>
//           )}
//           <button
//             className="cursor-pointer"
//             onClick={() => navigate("/profile")}
//           >
//             Profile
//           </button>
//         </div>

//         {/* Mobile Hamburger */}
//         <div className="md:hidden">
//           <button onClick={toggleMenu}>
//             {isOpen ? <X size={28} /> : <Menu size={28} />}
//           </button>
//         </div>
//       </section>

//       {/* Mobile Dropdown */}
//       {isOpen && (
//         <div className="md:hidden bg-white border-b border-gray-200 px-6 py-4 font-['HVD_Trial_Brandon_Grotesque'] text-[#003DA5] font-bold space-y-4">
//           <button
//             onClick={() => {
//               navigate("/who-we-are");
//               toggleMenu();
//             }}
//             className="block w-full text-left"
//           >
//             Who We Are
//           </button>
//           <button
//             onClick={() => {
//               navigate("/who-we-serve");
//               toggleMenu();
//             }}
//             className="block w-full text-left"
//           >
//             Who We Serve
//           </button>
//           <button
//             onClick={() => {
//               navigate("/how-to-support");
//               toggleMenu();
//             }}
//             className="block w-full text-left"
//           >
//             How to Support
//           </button>
//           <button
//             onClick={() => {
//               navigate("/news");
//               toggleMenu();
//             }}
//             className="block w-full text-left"
//           >
//             News
//           </button>
//           {isLoggedIn && (
//             <div>
//               <button
//                 onClick={toggleMobileVideoPlatformDropdown}
//                 className="block w-full text-left flex items-center gap-1"
//               >
//                 Video Platform
//                 <ChevronDown
//                   size={16}
//                   className={`transition-transform ${
//                     showMobileVideoPlatformDropdown ? "rotate-180" : ""
//                   }`}
//                 />
//               </button>
//               {showMobileVideoPlatformDropdown && (
//                 <div className="pl-4 bg-[#003DA5] text-white rounded-md mt-2">
//                   <button
//                     onClick={() => {
//                       navigate("/video-platform/regions");
//                       toggleMenu();
//                     }}
//                     className="block w-full text-left px-4 py-3 border-b border-white"
//                   >
//                     Regions
//                   </button>
//                   <button
//                     onClick={() => {
//                       navigate("/video-platform/industries");
//                       toggleMenu();
//                     }}
//                     className="block w-full text-left px-4 py-3 border-b border-white"
//                   >
//                     Industries
//                   </button>
//                   <button
//                     onClick={() => {
//                       navigate("/video-platform/videos");
//                       toggleMenu();
//                     }}
//                     className="block w-full text-left px-4 py-3 border-b border-white"
//                   >
//                     Videos
//                   </button>
//                 </div>
//               )}
//             </div>
//           )}
//           {isAdmin && (
//             <button
//               onClick={() => {
//                 navigate("/admin");
//                 toggleMenu();
//               }}
//               className="block w-full text-left"
//             >
//               Admin
//             </button>
//           )}
//           <button
//             onClick={() => {
//               navigate("/profile");
//               toggleMenu();
//             }}
//             className="block w-full text-left"
//           >
//             Profile
//           </button>
//         </div>
//       )}
//     </>
//   );
// }

import React, { useState } from "react";
import slulogo from "../assets/logo_image.png";
import { useNavigate } from "react-router-dom";
import { Menu, X, ChevronDown, ChevronUp } from "lucide-react";

export default function Navbar() {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [isVrpDropdownOpen, setIsVrpDropdownOpen] = useState(false);

  const isLoggedIn = Boolean(localStorage.getItem("authToken"));
  const isAdmin = isLoggedIn && localStorage.getItem("userType") === "admin";

  const toggleMenu = () => setIsOpen(!isOpen);
  const toggleVrpDropdown = () => setIsVrpDropdownOpen(!isVrpDropdownOpen);
  const closeVrpDropdown = () => setIsVrpDropdownOpen(false);

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("userType");
    navigate("/");
  };

  return (
    <>
      {/* Top strip */}
      <div className="flex justify-end bg-[#003da5] text-white p-3 font-['corporate-s']">
        <nav className="px-6 space-x-4 text-sm md:text-[16px] font-bold">
          {isLoggedIn ? (
            <button onClick={handleLogout} className="cursor-pointer">
              Logout
            </button>
          ) : (
            <button
              onClick={() => navigate("/login")}
              className="cursor-pointer"
            >
              Login
            </button>
          )}
          <button className="cursor-pointer">
            <a href="https://engage.slu.edu/register/fund?sys:gift:fund=5f1377c9-952f-f0e2-4d65-15e8a9161ad6&sys:gift:notes=GIFT99W9">
              Donate
            </a>
          </button>
          <button
            onClick={() => navigate("/contact")}
            className="cursor-pointer"
          >
            Contact Us
          </button>
        </nav>
      </div>

      {/* Main Navbar */}
      <section className="flex justify-between items-center bg-white border-b border-gray-300 px-6 h-28">
        {/* Logo */}
        <img
          src={slulogo}
          alt="TWA Logo"
          className="h-14 w-auto object-contain cursor-pointer transform scale-200 m-16"
          onClick={() => navigate("/")}
        />

        {/* Desktop Nav */}
        <div className="hidden md:flex justify-end pr-4 space-x-4 md:space-x-6 font-['corporate-s'] text-sm md:text-md lg:text-lg text-[#003DA5] font-bold">
          <button
            className="cursor-pointer"
            onClick={() => navigate("/who-we-are")}
          >
            Who We Are
          </button>
          <button
            className="cursor-pointer"
            onClick={() => navigate("/who-we-serve")}
          >
            Who We Serve
          </button>
          <button
            className="cursor-pointer"
            onClick={() => navigate("/how-to-support")}
          >
            How to Support
          </button>
          <button className="cursor-pointer" onClick={() => navigate("/news")}>
            News
          </button>
          {/*  <button
            className="cursor-pointer"
            onClick={() => navigate("/video-platform/regions")}
          >
            Faces of Talent(VRP)
          </button> */}
          {/* VRP Dropdown (Desktop) */}
          <div className="relative cursor-pointer">
            <button
              className="cursor-pointer flex items-center"
              onClick={toggleVrpDropdown}
            >
              Faces of Talent(VRP){" "}
              {isVrpDropdownOpen ? (
                <ChevronUp className="ml-1 h-4 w-4" />
              ) : (
                <ChevronDown className="ml-1 h-4 w-4" />
              )}
            </button>
            {isVrpDropdownOpen && (
              <div
                className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg z-10"
                onMouseLeave={closeVrpDropdown}
              >
                <button
                  className="block w-full text-left px-4 py-2 text-sm text-[#003DA5] cursor-pointer hover:bg-gray-100"
                  onClick={() => {
                    navigate("/video-platform/regions");
                    closeVrpDropdown();
                  }}
                >
                  Faces of Talent(VRP)
                </button>
                <button
                  className="block w-full text-left px-4 py-2 text-sm text-[#003DA5] cursor-pointer hover:bg-gray-100"
                  onClick={() => {
                    navigate("/video-platform/nextsteps"); // Navigate to the 'next steps' page
                    closeVrpDropdown();
                  }}
                >
                  Next Steps
                </button>
                <button
                  className=" block w-full text-left px-4 py-2 text-sm text-[#003DA5] cursor-pointer hover:bg-gray-100"
                  onClick={() => navigate("/profile")}
                >
                  Profile
                </button>
              </div>
            )}
          </div>

          {isAdmin && (
            <button
              className="cursor-pointer"
              onClick={() => navigate("/admin")}
            >
              Admin
            </button>
          )}
        </div>

        {/* Mobile Hamburger */}
        <div className="md:hidden">
          <button onClick={toggleMenu}>
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </section>

      {/* Mobile Dropdown */}
      {isOpen && (
        <div className="md:hidden bg-white border-b border-gray-200 px-6 py-4 font-['corporate-s'] text-[#003DA5] font-bold space-y-4 cursor-pointer">
          <button
            onClick={() => {
              navigate("/who-we-are");
              toggleMenu();
            }}
            className="block w-full cursor-pointer text-left"
          >
            Who We Are
          </button>
          <button
            onClick={() => {
              navigate("/who-we-serve");
              toggleMenu();
            }}
            className="block w-full cursor-pointer text-left"
          >
            Who We Serve
          </button>
          <button
            onClick={() => {
              navigate("/how-to-support");
              toggleMenu();
            }}
            className="block w-full cursor-pointer text-left"
          >
            How to Support
          </button>
          <button
            onClick={() => {
              navigate("/news");
              toggleMenu();
            }}
            className="block w-full cursor-pointer text-left"
          >
            News
          </button>
          {/* <button
            onClick={() => {
              navigate("/video-platform/regions");
              toggleMenu();
            }}
            className="block w-full text-left"
          >
            VRP
          </button> */}

          {/* VRP Dropdown (Mobile) - Added specific mobile handling */}
          <div>
            <button
              onClick={toggleVrpDropdown}
              className="flex items-center justify-between cursor-pointer w-full text-left"
            >
              Faces of Talent(VRP){" "}
              {isVrpDropdownOpen ? (
                <ChevronUp className="ml-1 h-4 w-4" />
              ) : (
                <ChevronDown className="ml-1 h-4 w-4" />
              )}
            </button>
            {isVrpDropdownOpen && (
              <div className="pl-4 mt-2 space-y-2">
                <button
                  className="block w-full cursor-pointer text-left text-sm"
                  onClick={() => {
                    navigate("/video-platform/regions");
                    toggleMenu();
                    closeVrpDropdown();
                  }}
                >
                  Faces of Talent(VRP)
                </button>
                <button
                  className="block w-full cursor-pointer text-left text-sm"
                  onClick={() => {
                    navigate("/video-platform/nextsteps");
                    toggleMenu();
                    closeVrpDropdown();
                  }}
                >
                  Next Steps
                </button>
                <button
                  onClick={() => {
                    navigate("/profile");
                    toggleMenu();
                  }}
                  className="block w-full cursor-pointer text-left text-sm"
                >
                  Profile
                </button>
              </div>
            )}
          </div>
          {isAdmin && (
            <button
              onClick={() => {
                navigate("/admin");
                toggleMenu();
              }}
              className="block w-full cursor-pointer text-left"
            >
              Admin
            </button>
          )}
        </div>
      )}
    </>
  );
}
